import { formatWithLeadingZero } from '@/core/helpers';

const dayConstraints = (value) => {
    // Only numbers are allowed
    value = value.replace(/\D/g, '');

    if ((value.length === 1 && parseInt(value, 10) > 3)){
        value = formatWithLeadingZero(value);
    }

    if(parseInt(value, 10) > 31){
        value = `${value}`[1]
    }

    return value;
}

const monthConstraints = (value) => {
    // Only numbers are allowed
    value = value.replace(/\D/g, '');

    if (value.length === 1 && parseInt(value, 10) > 1) {
        value = formatWithLeadingZero(value);
    }

    if(parseInt(value, 10) > 12){
        value = `${value}`[1]
    }

    return value;
}

const yearConstraints = (value) => {
    value = `${value}`.replace(/\D/g, '');

    // Parse the current value to an integer
    let year = parseInt(value, 10);

    // If the value is empty or not a number, return early
    if (isNaN(year)) {
        return;
    }

    // Ensure the length of the input is valid
    if (year.length > 4) {
        year = year.slice(0, 4);
    }

    return year;
}

const yearOfBirthConstraints = (value) => {
    value = `${value}`.replace(/\D/g, '');

    // Define the valid year range
    const minYear = new Date().getFullYear() - 100;
    const maxYear = new Date().getFullYear() - 17;

    // Validate partial inputs based on their length
    switch (value.length) {
        case 1:
            // If the first digit is not 1 or 2, it's invalid
            if (value > '2') {
                value = value.slice(0, -1);
            }
            break;
        case 2:
            // If the first two digits are not 19 or 20, it's invalid
            if (value < 19 || value > 20) {
                value = value.slice(0, -1);
            }
            break;
        case 3:
            // If the first three digits are not after 192, it's invalid
            if (value < parseInt(minYear.toString().slice(0, 3)) || value > parseInt(maxYear.toString().slice(0,3))) {
                value = value.slice(0, -1);
            }
            break;
        case 4:
            // If the full year is not within the valid range, it's invalid
            if (value < minYear || value > maxYear) {
                value = value.slice(0, -1);
            }
            break;
    }

    return value;
}

const birthYearConstraints = (value) => {
    value = yearConstraints(value);
    value = yearOfBirthConstraints(value);

    return value;
}

const licenseIssueYearConstraints = (value, licenseYears) => {
    let nextValue = `${value ?? ''}`.replace(/\D/g, '');

    if (!nextValue) {
        return;
    }

    if (nextValue.length > 4) {
        nextValue = nextValue.slice(0, 4);
    }

    const parsedLicenseYears = Number.parseInt(licenseYears, 10);
    if (Number.isNaN(parsedLicenseYears)) {
        return nextValue;
    }

    const minYears = Math.max(0, parsedLicenseYears);
    const maxYears = minYears + 1;
    const today = new Date();
    const minDate = new Date(today);
    const maxDate = new Date(today);

    minDate.setFullYear(today.getFullYear() - maxYears);
    maxDate.setFullYear(today.getFullYear() - minYears);

    const minYear = minDate.getFullYear();
    const maxYear = maxDate.getFullYear();
    const minYearString = `${minYear}`;
    const maxYearString = `${maxYear}`;

    const prefixLength = nextValue.length;
    const prefixValue = Number.parseInt(nextValue, 10);
    const minPrefix = Number.parseInt(minYearString.slice(0, prefixLength), 10);
    const maxPrefix = Number.parseInt(maxYearString.slice(0, prefixLength), 10);

    if (prefixValue < minPrefix || prefixValue > maxPrefix) {
        return nextValue.slice(0, -1);
    }

    if (nextValue.length === 4) {
        const fullYear = Number.parseInt(nextValue, 10);
        if (fullYear < minYear || fullYear > maxYear) {
            return nextValue.slice(0, -1);
        }
    }

    return nextValue;
}

const isDateUpToToday = (date) => {
    const today = new Date();
    return date.year < today.getFullYear()
        || (date.year === today.getFullYear() && date.month <= today.getMonth() + 1);
}

export {
    birthYearConstraints, dayConstraints, isDateUpToToday, licenseIssueYearConstraints, monthConstraints,
    yearConstraints, yearOfBirthConstraints
};

